import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import { mapState, mapGetters, mapMutations } from 'vuex';
import Konva from 'konva';
let _ = require('lodash');
import { ElMessage, ElMessageBox, ElNotification } from 'element-plus';
export default {
  name: 'mapv2assembly',
  meta: {
    title: ''
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: {}
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  emits: ['selectNode'],
  components: {},
  emits: ['hide'],
  data() {
    return {
      stage: '',
      editlayer: '',
      tr: '',
      cnode: '',
      // elemInfo: {},
      // defaultpicImg: require('@/assets/mapv2/defaultImage.jpg'),
      defaultpicImg: 'https://p.cldisk.com/star3/origin/bcf319ee85abda331c2cae8b0ac6e71b.jpg',
      mainStyle: {
        width: '',
        height: ''
      },
      toolslayer: '',
      toolsList: {
        delete: {
          name: '删除',
          image: require('@/assets/icon/delete.png')
        }
      },
      id: 0
    };
  },
  created() {},
  computed: {
    ...mapGetters(['mapv2info'])
  },
  mounted() {
    this.$nextTick(() => {
      console.log(`domeditorvalue`, this.value);
      this.id = this.value.length;
      this.drawData(this.value);
    });
  },
  watch: {
    'mapv2info.domstyle': {
      handler(val) {
        if (val) this.changeNodeStyle(val);
      },
      deep: true
    },
    isMobile: {
      handler(val) {
        this.changeScreen(val);
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations(['SET_MAPFORMITEM']),
    /**
     * 创建舞台
     */
    initStage() {
      let that = this;
      let width = window.innerWidth;
      let height = window.innerHeight;
      this.stage = new Konva.Stage({
        container: document.querySelector('#DOMEditor'),
        width: width,
        height: height,
        draggable: false
      });
      // 修改类名
      let contentContainer = this.stage.content;
      contentContainer.className = 'stage-content';
      this.stage.on('click tap', e => {
        this.stageClick(e);
      });
      this.editlayer = new Konva.Layer();
      this.stage.add(this.editlayer);
      this.createtoolsLayer();
      this.createTranformer();
    },
    /**
     * 创建工具栏图层
     */
    createtoolsLayer() {
      let that = this;
      const toolsWidth = 28;
      this.toolslayer = new Konva.Layer();
      this.stage.add(this.toolslayer);
      let group = new Konva.Group({
        x: 100,
        y: 100,
        height: toolsWidth,
        name: 'tools'
      });
      const groupbg = new Konva.Rect({
        x: 0,
        y: 0,
        width: Object.keys(this.toolsList).length * toolsWidth + 10,
        height: toolsWidth + 4,
        fill: '#ffffff',
        shadowColor: 'rgba(0, 0, 0, 0.05)',
        shadowBlur: 8,
        cornerRadius: 4
      });
      group.add(groupbg);
      Object.keys(this.toolsList).forEach((tool, index) => {
        const imagegroup = new Konva.Group({
          x: toolsWidth * index + 5,
          y: 2,
          width: toolsWidth,
          height: toolsWidth
        });
        const imagebg = new Konva.Rect({
          x: 0,
          y: 0,
          width: toolsWidth,
          height: toolsWidth,
          fill: '#ffffff',
          cornerRadius: 4,
          name: `${tool}bg`
        });
        imagegroup.add(imagebg);
        let konvanode;
        const imageObj = new Image();
        imageObj.src = this.toolsList[tool].image;
        konvanode = new Konva.Image({
          x: 4,
          y: 4,
          width: 20,
          height: 20,
          image: imageObj,
          name: tool
        });
        konvanode.on('click', e => {
          console.log(`konvanode.click`, e);
          e.cancelBubble = true;
          that[`${e.target.getAttr('name')}Handle`](e);
        });
        konvanode.on('mouseenter', e => {
          console.log(`konvanode.mouseenter`, e);
          let name = e.target.getAttr('name');
          e.target.parent.find(`.${name}bg`)[0].setAttr('fill', '#f2f2f2');
          document.body.style.cursor = 'pointer';
        });
        konvanode.on('mouseout', e => {
          console.log(`konvanode.mouseout`, e);
          let name = e.target.getAttr('name');
          e.target.parent.find(`.${name}bg`)[0].setAttr('fill', '#ffffff');
          document.body.style.cursor = '';
        });
        imagegroup.add(konvanode);
        group.add(imagegroup);
      });
      this.toolslayer.add(group);
      this.toolslayer.hide();
      this.toolslayer.draw();
    },
    /**
     * 创建变换器
     */
    createTranformer() {
      let that = this;
      // new transformer
      this.tr = new Konva.Transformer({
        rotateEnabled: false,
        // 禁止旋转
        keepRatio: false,
        // 保持比例
        enabledAnchors: ['top-left', 'top-right', 'bottom-left', 'bottom-right'],
        anchorStroke: '#1261FF',
        anchorFill: '#ffffff',
        anchorSize: 5,
        borderStroke: '#08A1EF',
        borderDash: [3, 3],
        name: 'transformer'
      });
      this.editlayer.add(this.tr);
      /* bind events to the Transformer. You can use events: transform, transformstart, transformend, dragstart, dragmove, dragend */
      this.tr.on('transformstart', e => {
        that.nodeChange(e);
      });
      this.tr.on('transform', e => {
        that.nodeChange(e);
      });
      this.tr.on('transformend', e => {
        that.nodeChange(e);
      });
      this.tr.on('dragstart', e => {
        that.nodeChange(e);
      });
      this.tr.on('dragmove', e => {
        that.nodeChange(e);
      });
      this.tr.on('dragend', e => {
        that.nodeChange(e);
      });
    },
    /**
     * 舞台点击事件
     */
    stageClick(e) {
      console.log('点击stage', e);
      console.log(`this.tr`, this.tr);
      /* 点击stage 重置参数 */
      if (_.isEqual(e.target, this.stage)) {
        this.editlayer.getChildren().forEach(item => {
          item.setAttr('draggable', false);
        });
        this.tr.nodes([]);
        /* 点击stage 空白区域时 隐藏dom编辑器 */
        console.log('点击stage 空白区域时 隐藏dom编辑器');
        this.$emit('hide', false);
        return;
      }

      // do nothing if clicked NOT on our rectangles
      if (e.target.getParent().getType() === 'Group' && e.target.getParent().hasName('tools')) {
        console.log(222);
        // this.tr.nodes([])
        return;
      }
      const metaPressed = e.evt.shiftKey || e.evt.ctrlKey || e.evt.metaKey;
      const isSelected = this.tr.nodes().indexOf(e.target) >= 0;
      if (this.editlayer.getChildren().length > 0) {
        this.editlayer.getChildren().forEach(child => {
          child.setAttr('draggable', false);
        });
      }
      if (!metaPressed && !isSelected) {
        e.target.setAttr('draggable', true);
        this.tr.nodes([e.target]);
      } else if (metaPressed && isSelected) {
        const nodes = this.tr.nodes().slice();
        nodes.splice(nodes.indexOf(e.target), 1);
        this.tr.nodes(nodes);
      } else if (metaPressed && !isSelected) {
        const nodes = this.tr.nodes().concat([e.target]);
        this.tr.nodes(nodes);
      }
      this.tr.moveToTop();
      this.editlayer.batchDraw();
      this.nodeChange(true);
    },
    /**
     * 绘制初始数据
     */
    drawData(data) {
      let that = this;
      // console.log(`drawData`, data)
      if (this.stage === '') this.initStage();
      if (data.length > 0) {
        data.forEach(item => {
          let konvanode;
          console.log(`item.type`, item.type);
          /* 新增image */
          if (item.type === 'Image') {
            const imageObj = new Image();
            imageObj.src = item.image.length > 0 ? item.image[0].fileUrl : this.defaultpicImg;
            item.style.image = imageObj;
            item.style.draggable = false;
            konvanode = new Konva.Image(item.style);
            this.editlayer.add(konvanode);
          }
          this.editlayer.draw();
        });
      }
      this.tr.moveToTop();
      this.editlayer.batchDraw();
      // console.log(this.editlayer.getChildren());
    },
    /**
     * 新增node操作
    * @param {String} type 类型
     */
    addNode(val) {
      if (this.stage === '') this.initStage();
      if (this.editlayer.getChildren().length > 0) {
        this.editlayer.getChildren().forEach(child => {
          if (!(child instanceof Konva.Transformer)) child.setAttr('draggable', false);
        });
      }
      // console.log(`addNode`, val)
      let konvanode;
      /* 新增image */
      if (val.type === 'Image') {
        const imageObj = new Image();
        imageObj.src = this.defaultpicImg;
        konvanode = new Konva.Image({
          id: this.id,
          x: val.x,
          y: val.y,
          width: 90,
          height: 90,
          image: imageObj,
          draggable: true
        });
      }
      this.id++;
      this.editlayer.add(konvanode);
      this.tr.nodes([konvanode]);
      this.tr.moveToTop();
      this.editlayer.batchDraw();
      this.nodeChange();
      // console.log(this.stage);
      // console.log(this.tr);
      // console.log(this.editlayer.getChildren());
    },
    /**
     * 变形器触发事件
     */
    nodeChange(e) {
      console.log(`------ 变形器触发事件 -------`);
      console.log(e);
      console.log(`this.tr`, this.tr.nodes());
      this.SET_MAPFORMITEM({
        centerflag: true
      });
      let cnode = _.cloneDeep(this.tr.nodes()[0]);
      let currentNode = cnode.getAttrs();
      console.log(`id`, cnode.getAttr('id'));
      if (e === undefined) {
        console.log(`新增node`);
        let type = cnode.getClassName();
        let dragNode = {
          id: cnode.getAttr('id'),
          type: type,
          style: currentNode,
          flag: false,
          data: {}
        };
        if (type === 'Image') dragNode.image = [{
          fileUrl: cnode.getAttr('image').src
        }];
        this.$emit('addNode', dragNode);
      } else {
        console.log(`编辑node`);
        this.$emit('selectNode', cnode);
        if (e.type === 'dragend' || e.type === 'transformend') {
          this.$emit('savetrEndNode', cnode);
        }
      }
      let pos = [cnode.getAttr('x'), cnode.getAttr('y')];
      let tools = this.toolslayer.find('.tools');
      tools[0].setAttr('x', pos[0]);
      tools[0].setAttr('y', pos[1] - tools[0].getAttr('height') - 8);
      this.toolslayer.show();
      this.toolslayer.draw();
    },
    /**
     * map点击node触发事件
     */
    selectNode(val) {
      console.log(`selectNode`, val);
      console.log(`this.editlayer`, this.editlayer.getChildren());
      this.editlayer.getChildren().forEach(child => {
        child.setAttr('draggable', false);
        console.log(`child.getAttr('id')`, child.getAttr('id'));
        if (child.getAttr('id') === val.id) {
          child.setAttr('draggable', true);
          this.tr.nodes([child]);
          this.editlayer.batchDraw();
          this.nodeChange(true);
        }
      });
    },
    /* domeditor右侧内容管理 改变值触发 */
    changeNodeStyle(val) {
      console.log(`------ domeditor右侧内容管理 改变值触发 -------`);
      console.log(`mapv2info.domstyle`, val);
      let that = this;
      let cnode = this.tr.nodes()[0];
      let cAttrs = cnode.getAttrs();
      if (val.width !== undefined) {
        Object.keys(val).forEach(key => {
          cnode.setAttr(key, val[key]);
        });
        /* 右侧内容改变宽高时 比例设为1 */
        cnode.setAttr('scaleX', 1);
        cnode.setAttr('scaleY', 1);
      }
      if (val.image !== undefined) {
        const imageObj = new Image();
        imageObj.src = val.image.length === 0 ? this.defaultpicImg : val.image[0].fileUrl;
        imageObj.onload = () => {
          cnode.setAttr('width', imageObj.width);
          cnode.setAttr('height', imageObj.height);
          console.log(typeof cnode.image);
          console.log(`cnode.getClassName`, cnode.getClassName());
          console.log(`cnode instanceof Konva.Image`, cnode instanceof Konva.Image);
          console.log(`imageObj`, imageObj);
          cnode.image(imageObj);
          that.editlayer.draw();
          cnode.imagearr = val.image;
          that.$emit('changestyle', cnode);
        };
        return;
      }
      if (val.url !== undefined) {
        cnode.link = val;
      }
      this.$emit('changestyle', cnode);
    },
    /* domeditor重置数据 */
    resetNode(data) {
      // console.log(`------ domeditor重置数据 -------`)
      // console.log(`data`, data);
      if (this.editlayer.getChildren().length > 1) {
        /* 销毁layer下所有数据 */
        this.editlayer.destroyChildren();
        this.createTranformer();
        this.editlayer.draw();
      }
      // console.log(`this.editlayer`, this.editlayer)
      this.drawData(data);
    },
    /* 切换屏幕 */
    changeScreen(val) {
      if (val) {
        this.mainStyle.width = '375px';
        this.mainStyle.height = '667px';
        this.stage.setAttr('width', 375);
        this.stage.setAttr('height', 667);
      } else {
        this.mainStyle.width = `100%`;
        this.mainStyle.height = `100%`;
        this.stage.setAttr('width', window.innerWidth);
        this.stage.setAttr('height', window.innerHeight);
      }
    },
    deleteHandle(val) {
      console.log(`------ 删除当前节点 -------`);
      console.log(`val`, val);
      let cnode = this.tr.nodes()[0];
      console.log(`cnode`, cnode);
      let that = this;
      ElMessageBox.confirm('确定要删除么？', '温馨提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        that.editlayer.getChildren().forEach(child => {
          if (child.getAttr('id') === cnode.getAttr('id')) child.remove();
        });
        that.toolslayer.hide();
        that.toolslayer.draw();
        that.tr.nodes([]);
        that.editlayer.draw();
        console.log(`that.editlayer`, that.editlayer);
        that.$emit('deleteNode', cnode);
      }).catch(() => {});
    }
  }
};